<div
    [class]="`flex items-center flex-row cursor-pointer ${containerClass()}`"
    (click)="onClick($event)">
    <app-radio-button
        [checked]="checked()"
        [class]="radioClass()"
        (radioClick)="onClick($event)" />

    <p class="text-xl font-normal">
        {{ label() }}
    </p>
</div>
